import { IFestivalResponse } from "@features/landing/types";
import { FESTIVAL_TYPE } from "@features/landing/types";
import StepsLanding from "./steps";
import { festivalUnit } from "@features/landing/helpers/constants/constants";

interface Props {
  festivalData?: IFestivalResponse;
}

const FestivalSteps: React.FC<Props> = ({ festivalData }) => {
  const festival = festivalData?.data?.festival;
  const steps = festivalData?.data?.steps ?? [];

  const festivalType = festival?.type ?? FESTIVAL_TYPE.WONDER;
  const discountText = festival?.discount_text ?? "";

  const unit = festivalUnit[festivalType];

  const stepsDescription = `در این طرح، با توجه به ${unit} آموزش در سبد سفارش خود، تا ${discountText} تخفیف ویژه دریافت کنید.`;

  return (
    <section
      id="festivalDiscount"
      className="my-16 flex flex-col items-center justify-center px-6"
    >
      <h3 className="mb-2 text-2xl font-bold text-zinc-900">
        تخفیف‌های جشنواره
      </h3>

      <p className="text-base font-normal text-zinc-500 text-center max-w-[600px]">
        {stepsDescription}
      </p>

      <StepsLanding
        data={steps}
        discount={discountText}
        festivalType={festivalType}
      />
    </section>
  );
};

export default FestivalSteps;
